import Swiper from 'swiper/bundle';
import Lenis from '@studio-freight/lenis';

/*-------------------------------------
 Lenis設定（スムーススクロール）
--------------------------------------*/
const lenis = new Lenis();
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);


/*-------------------------------------
 スクロール時の処理
--------------------------------------*/
let startPos = 0;
let winScrollTop = 0;
let threshold = window.innerHeight;
let headerHeight = document.querySelector('header').offsetHeight;
let taglineHeight = document.querySelector('.tagline').offsetHeight;
let headerOffset = headerHeight + taglineHeight;

window.addEventListener('scroll', () => {
  winScrollTop = window.scrollY;

  if (winScrollTop !== 0) {
    document.body.classList.add('is-scroll');
  } else {
    document.body.classList.remove('is-scroll');
  }

  // ヘッダーの固定処理
  const header = document.querySelector('header');
  if (winScrollTop >= taglineHeight) {
    header.classList.add('is-fixed');
  } else {
    header.classList.remove('is-fixed');
  }

  if (winScrollTop >= startPos) {
    if (winScrollTop >= threshold) {
      document.body.classList.add('is-down');
    }
  } else {
    document.body.classList.remove('is-down');
  }
  startPos = winScrollTop;
});

window.addEventListener('resize', () => {
  threshold = window.innerHeight;
  headerHeight = document.querySelector('header').offsetHeight;
  taglineHeight = document.querySelector('.tagline').offsetHeight;
  headerOffset = headerHeight + taglineHeight;
});

/*-------------------------------------
 メニュー開閉・トグル関連
--------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  initSwiper();
	rollText();
  document.body.classList.add('is-ready');
  

  const menuButton = document.getElementById('menuButton');
  if (menuButton) {
    const gnav = document.getElementById('gnav');
    let isMenuOpen = false;
    let scrollPos = 0;

    menuButton.addEventListener('click', () => {
      menuButton.classList.toggle('show');
      gnav.classList.toggle('show');
      if (!isMenuOpen) {
        scrollPos = window.scrollY;
        document.body.classList.add('fixed');
        document.body.style.top = `-${scrollPos}px`;
        isMenuOpen = true;
      } else {
        closeMenu();
      }
    });

    function closeMenu() {
      menuButton.classList.remove('show');
      gnav.classList.remove('show');
      document.body.classList.remove('fixed');
      document.body.style.top = '0';
      window.scrollTo(0, scrollPos);
      isMenuOpen = false;
    }

    Array.from(gnav.querySelectorAll('a')).forEach(link => {
      link.addEventListener('click', closeMenu);
    });

    // メニュー以外をクリックしたら閉じる
    document.addEventListener('click', (e) => {
      if (!gnav.contains(e.target) && !menuButton.contains(e.target) && isMenuOpen) {
        closeMenu();
      }
    });

    // リサイズ対応
    function handleResize() {
      if (window.innerWidth >= 768) {
        document.body.classList.remove('fixed');
        document.body.style.top = '0';
      }
    }
    window.addEventListener('load', handleResize);
    window.addEventListener('resize', handleResize);
  }

  /*-------------------------------------
   ページトップボタン
  --------------------------------------*/
  const pagetop = document.getElementById('pagetop');
  if (pagetop) {
    pagetop.addEventListener('click', () => {
      lenis.scrollTo(0);
    });
  }

  const faqElements = document.querySelectorAll('.type_faq');
  if (faqElements.length) {
    faqElements.forEach(faq => {
      const questions = faq.querySelectorAll('.q');
      questions.forEach(question => {
        question.addEventListener('click', () => {
          question.classList.toggle('active');
          const nextElement = question.nextElementSibling;
          
          if (nextElement.style.display === 'none' || !nextElement.style.display) {
            nextElement.style.display = 'block';
          } else {
            nextElement.style.display = 'none';
          }
        });
      });
    });
  }
});

const accordionElements = document.querySelectorAll('.accordion');
if (accordionElements.length) {
  accordionElements.forEach(accordion => {
    const heading = accordion.querySelector('h3');
    const desc = accordion.querySelector('.desc');
    
    if (heading && desc) {
      // 実際の高さを取得して保存
      desc.setAttribute('data-height', desc.scrollHeight + 'px');
      
      // SP-onlyの場合、PCではdescを常に表示、SPでは非表示
      const handleResize = () => {
        if (accordion.classList.contains('sp-only')) {
          if (window.innerWidth >= 768) {
            desc.style.height = desc.getAttribute('data-height');
            desc.style.display = 'block';
          } else {
            desc.style.height = '0';
            accordion.classList.remove('is-open');
          }
        }
      };
      
      window.addEventListener('resize', handleResize);
      handleResize(); // 初期化時にも実行
      
      heading.addEventListener('click', () => {
        // PCでsp-onlyの場合はクリックイベントを無効化
        if (accordion.classList.contains('sp-only') && window.innerWidth >= 768) {
          return;
        }
        
        accordion.classList.toggle('is-open');
        
        if (!accordion.classList.contains('is-open')) {
          desc.style.height = '0';
        } else {
          desc.style.height = desc.getAttribute('data-height');
        }
      });
    }
  });
}



/*-------------------------------------
 Swiper初期化
--------------------------------------*/
function initSwiper() {
  const topSlider = new Swiper('#topSlider', {
    slidesPerView: 'auto',
    loop: true,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        centeredSlides: true,
      }
    }
  });
}

const itemDetailThumbsSwiper = new Swiper('#itemDetailThumbsSwiper', {
  slidesPerView: 'auto',
  freeMode: true,
  watchSlidesProgress: true,
  spaceBetween: 10,
  
});

const itemDetailSwiper = new Swiper('#itemDetailSwiper', {
  slidesPerView: 1,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: itemDetailThumbsSwiper,
  },
});




/*-------------------------------------
 roll text
--------------------------------------*/

function rollText() {
	document.querySelectorAll('.roll-text .parent').forEach(button => button.innerHTML = '<span class="child"><i>' + button.textContent.trim().split('').join('</i><i>') + '</i></span>');
	document.querySelectorAll('#intro .parent').forEach(button => button.innerHTML = '<span class="child"><i>' + button.textContent.trim().split('').join('</i><i>') + '</i></span>');
}

/*-------------------------------------
 SPメニューのサブメニュー表示
--------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const spMenuContents = document.getElementById('spMenuContents');
  const spMenuTitle = document.getElementById('spMenuTitle');
  const backSpMenu = document.getElementById('backSpMenu');
  const titleHeading = spMenuTitle?.querySelector('h2');
  
  if (spMenuContents && spMenuTitle && backSpMenu && titleHeading) {
    // 元のメニューコンテンツを保存
    const originalContents = spMenuContents.innerHTML;
    
    // サブメニューを開く処理
    document.querySelectorAll('.open-submenu').forEach(submenuBtn => {
      submenuBtn.addEventListener('click', () => {
        // クリックされたサブメニューのタイトルを取得
        const submenuTitle = submenuBtn.textContent;
        // 隣接するulを取得
        const submenuContent = submenuBtn.nextElementSibling;
        
        if (submenuContent && submenuContent.tagName === 'UL') {
          // サブメニューの内容をspMenuContentsに設定
          spMenuContents.innerHTML = submenuContent.outerHTML;
          
          // タイトル部分の表示を変更
          titleHeading.style.display = 'none';
          backSpMenu.style.display = 'block grid';
          backSpMenu.classList.add('is-show');
          
          // 必要に応じてクラスを追加
          spMenuContents.classList.add('submenu-active');
        }
      });
    });
    
    // 戻るボタンの処理
    backSpMenu.addEventListener('click', () => {
      // 元のメニューコンテンツに戻す
      spMenuContents.innerHTML = originalContents;
      
      // タイトル部分を元に戻す
      titleHeading.style.display = 'block grid';
      backSpMenu.style.display = 'none';
      backSpMenu.classList.remove('is-show');
      
      // クラスを削除
      spMenuContents.classList.remove('submenu-active');
      
      // サブメニューを開く処理を再度バインド
      document.querySelectorAll('.open-submenu').forEach(submenuBtn => {
        submenuBtn.addEventListener('click', function() {
          const submenuContent = this.nextElementSibling;
          if (submenuContent && submenuContent.tagName === 'UL') {
            spMenuContents.innerHTML = submenuContent.outerHTML;
            titleHeading.style.display = 'none';
            backSpMenu.style.display = 'block grid';
            backSpMenu.classList.add('is-show');
            spMenuContents.classList.add('submenu-active');
          }
        });
      });
    });
  }
});

/*-------------------------------------
 SPメニューの開閉処理
--------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  // メニュー開閉処理を関数化
  function setupMenu(openBtnId, closeBtnId, menuId) {
    const openBtn = document.getElementById(openBtnId);
    const closeBtn = document.getElementById(closeBtnId);
    const menu = document.getElementById(menuId);
    
    if (openBtn && closeBtn && menu) {
      openBtn.addEventListener('click', () => {
        menu.classList.add('is-show');
      });
      
      closeBtn.addEventListener('click', () => {
        menu.classList.remove('is-show');
      });
    }
  }

  // 左側メニューと右側メニューの設定を関数で処理
  setupMenu('openSpMenu', 'closeSpMenu', 'spMenu');
  setupMenu('openSpRightMenu', 'closeSpRightMenu', 'spRightMenu');
});

/*-------------------------------------
 記事ナビゲーションのアコーディオン機能
--------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  // 記事ナビゲーションのアコーディオン
  const articleNavItems = document.querySelectorAll('.article-nav .navwrapper .main > li > h3');
  
  if (articleNavItems.length) {
    articleNavItems.forEach(item => {
      // 直後のul（サブメニュー）を取得
      const subMenu = item.nextElementSibling;
      
      if (subMenu && subMenu.tagName === 'UL') {
        
        // 実際の高さを取得して保存
        subMenu.setAttribute('data-height', subMenu.scrollHeight + 'px');
      }
      
      item.addEventListener('click', function() {
        // クリックされた要素に.is-showクラスをトグル
        this.classList.toggle('is-show');
        
        // 直後のul（サブメニュー）を取得
        const subMenu = this.nextElementSibling;
        if (subMenu && subMenu.tagName === 'UL') {
          // サブメニューにも.is-showクラスをトグル
          subMenu.classList.toggle('is-show');
          
          // 高さを切り替える
          if (subMenu.classList.contains('is-show')) {
            subMenu.style.height = subMenu.getAttribute('data-height');
          } else {
            subMenu.style.height = '0';
          }
        }
      });
    });
  }
});



/**
 * 在庫数に基づいてセレクトボックスのオプションを生成する
 */
document.addEventListener('DOMContentLoaded', function() {
  
  // すべての.itemUnitを取得
  const itemUnits = document.querySelectorAll('.itemUnit');
  
  if (itemUnits.length === 0) return;
  
  // 各itemUnitに対して処理
  itemUnits.forEach((itemUnit, index) => {
    // .amountSelectを取得
    const amountSelect = itemUnit.querySelector('.amountSelect');
    if (!amountSelect) {
      return;
    }
    
    // 在庫数をdata-stock属性から取得
    const stockCount = parseInt(amountSelect.getAttribute('data-stock'), 10);
    
    if (isNaN(stockCount) || stockCount <= 0) {
      return;
    }
    
    // 既存のオプションをクリア
    amountSelect.innerHTML = '';
    
    // 在庫数に基づいてオプションを生成（最大99個まで）
    const maxOptions = Math.min(stockCount, 99);
    
    for (let i = 1; i <= maxOptions; i++) {
      const option = document.createElement('option');
      option.value = i;
      option.textContent = i;
      amountSelect.appendChild(option);
    }
    
    // 同じitemUnit内のbrand_infoのinputを取得
    const brandInfoInput = itemUnit.querySelector('input[name="brand_info"]');
    
    // セレクトボックスの変更イベントを監視
    amountSelect.addEventListener('change', function() {
      if (brandInfoInput) {
        // 現在のvalueを取得
        const currentValue = brandInfoInput.value;
        // カンマで分割
        const valueParts = currentValue.split(',');
        
        if (valueParts.length === 3) {
          // 最後の部分を選択された数量に置き換え
          valueParts[2] = this.value;
          // 新しい値を設定
          brandInfoInput.value = valueParts.join(',');
        }
      }
    });
    
    // カートに入れるボタンのクリックイベント処理
    const addCartButton = itemUnit.querySelector('button.addCart');
    if (addCartButton && addCartButton.getAttribute('type') === 'button') {
      addCartButton.addEventListener('click', function() {
        // 親のformを取得
        const form = this.closest('form');
        if (form) {
          // フォームを送信
          form.submit();
        }
      });
    }
    
    // ページロード時にbrand_infoの値とセレクトボックスの値を同期させる
    if (brandInfoInput) {
      const currentValue = brandInfoInput.value;
      const valueParts = currentValue.split(',');
      
      if (valueParts.length === 3) {
        const quantity = parseInt(valueParts[2], 10);
        if (!isNaN(quantity) && quantity > 0 && quantity <= maxOptions) {
          amountSelect.value = quantity;
        } else {
          // 数量が不正な場合は1に設定し、brand_infoも更新
          amountSelect.value = 1;
          valueParts[2] = '1';
          brandInfoInput.value = valueParts.join(',');
        }
      }
    }
    
    // ブラウザのバック/フォワード操作を検出して同期を行う
    window.addEventListener('pageshow', function(event) {
      
      // persisted の値に関わらず同期処理を実行する
      if (brandInfoInput) {
        const currentValue = brandInfoInput.value;
        const valueParts = currentValue.split(',');
        
        if (valueParts.length === 3) {
          const quantity = parseInt(valueParts[2], 10);
          if (!isNaN(quantity) && quantity > 0 && quantity <= maxOptions) {
            amountSelect.value = quantity;
            console.log(`itemUnit ${index}: restored amountSelect to ${quantity}`); // デバッグログ追加
          } else {
            // 数量が不正な場合は1に設定し、brand_infoも更新
            amountSelect.value = 1;
            valueParts[2] = '1';
            brandInfoInput.value = valueParts.join(',');
            console.log(`itemUnit ${index}: reset to 1, new brand_info: ${brandInfoInput.value}`); // デバッグログ追加
          }
        } else {
          console.log(`itemUnit ${index}: unexpected brand_info format, parts: ${valueParts.length}`); // デバッグログ追加
        }
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const itemDetail = document.querySelectorAll('.itemDetail');

  if (itemDetail.length === 0) return;

  itemDetail.forEach((itemDetail, index) => {
      const amountSelect = itemDetail.querySelector('.amountSelect');
    if (!amountSelect) {
      return;
    }

    const stockCount = parseInt(amountSelect.getAttribute('data-stock'), 10);

    if (isNaN(stockCount) || stockCount <= 0) {
      return;
    }
    amountSelect.innerHTML = '';
    
    const maxOptions = Math.min(stockCount, 99);
    
    for (let i = 1; i <= maxOptions; i++) {
      const option = document.createElement('option');
      option.value = i;
      option.textContent = i;
      amountSelect.appendChild(option);
    }
  });

});

/*-------------------------------------
 カテゴリーページのフィルター機能
--------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const filterSelect = document.querySelector('.filterSelect');
  
  if (filterSelect) {
    filterSelect.addEventListener('change', function() {
      const selectedValue = this.value;
      
      if (selectedValue !== '') {
        window.location.href = selectedValue;
      }
    });
  }
});

document.querySelectorAll('.search-keyword, .search-price, .original-code').forEach(element => {
  element.addEventListener('keypress', (e) => {
    if (e.keyCode === 13) {
      document.querySelector('.search-url').click();
    }
  });
});

/*-------------------------------------
 カート追加時のローディング表示
--------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  
  // .itemListModuleが存在する場合の処理
  const itemListModules = document.querySelectorAll('.itemListModule');
  if (itemListModules.length > 0) {
    itemListModules.forEach(itemListModule => {
      const addCartButtons = itemListModule.querySelectorAll('.addCart');
      
      addCartButtons.forEach(button => {
        button.addEventListener('click', function(e) {
          // すでにローディング中なら処理しない
          if (this.classList.contains('is-loading')) {
            return;
          }
          
          // is-loadingクラスを追加
          this.classList.add('is-loading');
          
          // 2秒後にクラスを削除
          setTimeout(() => {
            this.classList.remove('is-loading');
          }, 2000);
        });
      });
    });
  }
});